import React, { useEffect, useRef, useState } from 'react';
import { BellIcon } from '@heroicons/react/24/outline';
import './NotificationBell.css';

const NotificationBell = ({
  notifications = [],
  buttonClassName = 'topbar-notify-btn',
  className = '',
  emptyText = 'Chưa có thông báo quan trọng.',
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const count = notifications.length;

  useEffect(() => {
    if (!open) return undefined;

    const handlePointerDown = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setOpen(false);
    };

    document.addEventListener('mousedown', handlePointerDown);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('mousedown', handlePointerDown);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [open]);

  return (
    <div className={`notification-bell-wrap ${className}`} ref={ref}>
      <button
        className={buttonClassName}
        aria-label={`Thông báo${count ? `: ${count} mục quan trọng` : ''}`}
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
        type="button"
      >
        <BellIcon className="w-5 h-5" />
        {count > 0 && <span className="notification-count-badge">{Math.min(count, 9)}</span>}
      </button>

      {open && (
        <section className="notification-panel" aria-label="Thông báo quan trọng">
          <div className="notification-panel-header">
            <strong>Thông báo quan trọng</strong>
            <span>{count ? `${count} mục` : 'Đã sạch'}</span>
          </div>
          {count === 0 ? (
            <div className="notification-empty">{emptyText}</div>
          ) : (
            <div className="notification-list">
              {notifications.map((item) => (
                <article className={`notification-item ${item.tone || 'info'}`} key={item.id}>
                  <span className="notification-dot" />
                  <div>
                    <strong>{item.title}</strong>
                    <p>{item.message}</p>
                    {item.timeLabel && <small>{item.timeLabel}</small>}
                  </div>
                </article>
              ))}
            </div>
          )}
        </section>
      )}
    </div>
  );
};

export default NotificationBell;
